;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();import get from "lodash/get"
import map from "lodash/map"
import keys from "lodash/keys"
import {
  PROFILE_BASICS,
  PROFILE_BASICS_PRONOUNS,
  PROFILE_BASICS_TITLE,
  PROFILE_BASICS_SHOW_TITLE,
  PROFILE_LIVED_EXPERIENCE,
  PROFILE_BASICS_CREDENTIAL_ABBREVIATIONS,
  PROFILE_ETHNICITY_AND_CULTURE_KEY,
  PROFILE_ETHNICITY_AND_CULTURE_LIST_KEY,
  PROFILE_ETHNICITY_AND_CULTURE_OTHER_OPTION_KEY,
  PROFILE_FAITH_KEY,
  PROFILE_FAITH_LIST_KEY,
  PROFILE_FAITH_OTHER_OPTION_KEY,
  PROFILE_GENDER_KEY,
  PROFILE_GENDER_LIST_KEY,
  PROFILE_GENDER_OTHER_OPTION_KEY,
  PROFILE_ORIENTATION_KEY,
  PROFILE_ORIENTATION_LIST_KEY,
  PROFILE_ORIENTATION_OTHER_OPTION_KEY,
  PROFILE_LANGUAGE_KEY,
  PROFILE_LANGUAGE_LIST_KEY,
  PROFILE_LANGUAGE_OTHER_OPTION_KEY,
  PROFILE_MODALITIES,
  PROFILE_MODALITIES_LIST_KEY,
  PROFILE_PERSONALITIY_CASUAL_FORMAL,
  PROFILE_PERSONALITIY_PLAYFUL_ERNEST,
  PROFILE_PERSONALITIY_CALM_ENERGETIC,
  PROFILE_PERSONALITIY_STREET_SMART_BOOK_SMART,
  PROFILE_PERSONALITIY_ACCOMODATING_CHALLENGING,
  PROFILE_PERSONALITIY_DREAMER_OBJECTIVE,
  PROFILE_PERSONALITIY,
  PROFILE_YOUR_STORY,
  PROFILE_CREDENTIALS,
} from "../constants"

export const getPronouns = ({ provider }) => {
  // console.log("getProviderPronouns", provider)
  return get(
    provider,
    `profileContent[${PROFILE_BASICS}][${PROFILE_BASICS_PRONOUNS}]`,
    null,
  )
}
export const getTitle = ({ provider }) => {
  return get(
    provider,
    `profileContent[${PROFILE_BASICS}][${PROFILE_BASICS_TITLE}]`,
    null,
  )
}
export const getShowTitle = ({ provider }) => {
  return get(
    provider,
    `profileContent[${PROFILE_BASICS}][${PROFILE_BASICS_SHOW_TITLE}]`,
    null,
  )
}
export const getBasicProfileCredentials = ({ provider }) => {
  return get(
    provider,
    `profileContent[${PROFILE_BASICS}][${PROFILE_BASICS_CREDENTIAL_ABBREVIATIONS}]`,
    null,
  )
}
export const getCredentials = ({ provider }) => {
  return get(provider, `profileContent[${PROFILE_CREDENTIALS}]`, [])
}

export const getEthnicityAndCulture = ({ provider }) => {
  return get(
    provider,
    `profileContent[${PROFILE_LIVED_EXPERIENCE}][${PROFILE_ETHNICITY_AND_CULTURE_KEY}][${PROFILE_ETHNICITY_AND_CULTURE_LIST_KEY}]`,
    [],
  )
}
export const getFaith = ({ provider }) => {
  return get(
    provider,
    `profileContent[${PROFILE_LIVED_EXPERIENCE}][${PROFILE_FAITH_KEY}][${PROFILE_FAITH_LIST_KEY}]`,
    [],
  )
}
export const getGender = ({ provider }) => {
  return get(
    provider,
    `profileContent[${PROFILE_LIVED_EXPERIENCE}][${PROFILE_GENDER_KEY}][${PROFILE_GENDER_LIST_KEY}]`,
    [],
  )
}
export const getOrientation = ({ provider }) => {
  return get(
    provider,
    `profileContent[${PROFILE_LIVED_EXPERIENCE}][${PROFILE_ORIENTATION_KEY}][${PROFILE_ORIENTATION_LIST_KEY}]`,
    [],
  )
}
export const getLanguage = ({ provider }) => {
  return get(
    provider,
    `profileContent[${PROFILE_LIVED_EXPERIENCE}][${PROFILE_LANGUAGE_KEY}][${PROFILE_LANGUAGE_LIST_KEY}]`,
    [],
  )
}

export const getModalities = ({ provider }) => {
  return get(
    provider,
    `profileContent[${PROFILE_MODALITIES}][${PROFILE_MODALITIES_LIST_KEY}]`,
    [],
  )
}

export const getCasualFormal = ({ provider }) => {
  return get(
    provider,
    `profileContent[${PROFILE_PERSONALITIY}][${PROFILE_PERSONALITIY_CASUAL_FORMAL}]`,
    null,
  )
}

export const getPlayfulErnest = ({ provider }) => {
  return get(
    provider,
    `profileContent[${PROFILE_PERSONALITIY}][${PROFILE_PERSONALITIY_PLAYFUL_ERNEST}]`,
    null,
  )
}

export const getCalmEnergetic = ({ provider }) => {
  return get(
    provider,
    `profileContent[${PROFILE_PERSONALITIY}][${PROFILE_PERSONALITIY_CALM_ENERGETIC}]`,
    null,
  )
}

export const getStreetSmartBookSmart = ({ provider }) => {
  return get(
    provider,
    `profileContent[${PROFILE_PERSONALITIY}][${PROFILE_PERSONALITIY_STREET_SMART_BOOK_SMART}]`,
    null,
  )
}

export const getAccomodatingChallenging = ({ provider }) => {
  return get(
    provider,
    `profileContent[${PROFILE_PERSONALITIY}][${PROFILE_PERSONALITIY_ACCOMODATING_CHALLENGING}]`,
    null,
  )
}

export const getDreamerObjective = ({ provider }) => {
  return get(
    provider,
    `profileContent[${PROFILE_PERSONALITIY}][${PROFILE_PERSONALITIY_DREAMER_OBJECTIVE}]`,
    null,
  )
}

export const getYourStory = ({ provider }) => {
  return get(provider, `profileContent[${PROFILE_YOUR_STORY}]`, null)
}
